/**
 * Custom Cart Drawer - Subscription Switching
 * Handles selling plan changes via Shopify Cart API (/cart/change.js)
 *
 * ARCHITECTURE: All event listeners are bound at the document level using
 * event delegation, so they survive innerHTML replacements from Dawn's
 * CartDrawer.renderContents() and CartItems.updateQuantity().
 */
(function () {
  // Use event delegation on document — survives any innerHTML replacement
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.classList || !select.classList.contains('cart-item__subscription-dropdown')) return;

    // CRITICAL: Stop propagation so Dawn's cart.js CartItems.onChange() doesn't
    // intercept this and call updateQuantity with undefined data-index.
    event.stopPropagation();
    event.preventDefault();

    var lineIndex = parseInt(select.getAttribute('data-line'), 10);
    var planId = select.value ? parseInt(select.value, 10) : '';

    // Get current quantity from the quantity input for this line item
    var quantityInput = document.getElementById('Drawer-quantity-' + lineIndex);
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    select.disabled = true;

    // Shopify Cart API: quantity is REQUIRED when changing selling_plan
    var payload = {
      line: lineIndex,
      quantity: quantity,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };

    // selling_plan: '' removes the plan (one-time), selling_plan: id sets it
    payload.selling_plan = (planId === '') ? '' : planId;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed: ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (data.sections) {
          updateCartDrawerSections(data.sections);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('[Subscription Switch] Error:', err);
        select.disabled = false;
      });
  }, true); // useCapture = true so we catch before Dawn's listener

  /**
   * Shared cart drawer section updater.
   * Replaces cart items, footer, and header with fresh HTML from Section Rendering API.
   */
  window._updateCartDrawerSections = updateCartDrawerSections;

  function updateCartDrawerSections(sections) {
    if (sections['cart-drawer']) {
      // Capture old progress bar width before replacing HTML
      var oldBar = document.querySelector('.progress_bar_line_above');
      var oldWidth = oldBar ? oldBar.style.width : '0%';

      var parser = new DOMParser();
      var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

      var pairs = [
        ['#CartDrawer-CartItems', '#CartDrawer-CartItems'],
        ['.drawer__footer', '.drawer__footer'],
        ['.drawer__header', '.drawer__header']
      ];

      pairs.forEach(function (sel) {
        var newEl = doc.querySelector(sel[0]);
        var curEl = document.querySelector(sel[1]);
        if (newEl && curEl) curEl.innerHTML = newEl.innerHTML;
      });

      // Animate progress bar from old width to new width
      animateProgressBar(oldWidth);
    }

    if (sections['cart-icon-bubble']) {
      var bp = new DOMParser();
      var bd = bp.parseFromString(sections['cart-icon-bubble'], 'text/html');
      var nb = bd.querySelector('.cart-count-bubble');
      var cb = document.querySelector('.cart-count-bubble');
      if (nb && cb) cb.innerHTML = nb.innerHTML;
    }

    // Dispatch event so other scripts can re-initialize
    document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
  }

  // Shared progress bar animation
  var lastProgressWidth = '0%';
  function animateProgressBar(fromWidth) {
    var bar = document.querySelector('.progress_bar_line_above');
    if (!bar) return;
    var targetWidth = bar.style.width;
    var from = fromWidth || lastProgressWidth;
    bar.style.transition = 'none';
    bar.style.width = from;
    bar.offsetWidth; // force reflow
    bar.style.transition = 'width 0.6s ease';
    bar.style.width = targetWidth;
    lastProgressWidth = targetWidth;
  }

  // Track initial bar width
  var initBar = document.querySelector('.progress_bar_line_above');
  if (initBar) lastProgressWidth = initBar.style.width;

  // MutationObserver to catch Dawn's cart.js updates (which bypass updateCartDrawerSections)
  var header = document.querySelector('.drawer__header');
  if (header) {
    new MutationObserver(function() {
      var bar = document.querySelector('.progress_bar_line_above');
      if (bar && bar.style.width !== lastProgressWidth) {
        animateProgressBar(lastProgressWidth);
      }
    }).observe(header, { childList: true, subtree: true });
  }
})();
